import { TableFilterProperties } from "@app/shared/model/action.model";
import { DbObject } from "@app/shared/model/db-object.model";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface ProjectFilterInt {
    folderId: number;
    projectId: number;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface ProjectFilterData {
    folder_id: number;
    project_id: number;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class ProjectFilter extends DbObject {
    static dbTypeName = "Custom Filter";
    static dbEndpoint = "folder_project";

    static readonly importMap: ImportMap<ProjectFilterInt, ProjectFilterData> = [
        { i: "folder_id", o: "folderId" },
        { i: "project_id", o: "projectId" },
    ];

    static fromDbObject(projectFilter): ProjectFilter {
        return new ProjectFilter(projectFilter[ProjectFilter.importMap[0].i], projectFilter[ProjectFilter.importMap[1].i]);
    }

    constructor(public folderId?: number | null, public projectId?: number | null) {
        super();
    }
}

export interface TemporaryProjectFilter extends TableFilterProperties {
    view?: undefined | number;
}
